import { ChangeDetectorRef, Component, DoCheck, EventEmitter, HostListener, OnInit, Output, ViewChildren } from '@angular/core'
import { RoutineService } from '../daily-content-v2/routine.service';
import { HabitService } from '../habit/habit.service';
import { CalendarService } from '../calendar.service';
import { collapseAnimation, collapseOnLeaveAnimation, expandOnEnterAnimation, slideOutRightAnimation } from 'angular-animations';
import { CompletedReviewModalComponent } from '../completed-review-modal/completed-review-modal.component';
import { IonItemSliding, ModalController, Platform } from '@ionic/angular';
import { RoutineV2Service } from '../routine-v2/routine-v2.service';
import { AppState } from '../app.service';
import { DailyStepsService } from '../daily-steps/daily-steps.service';
import { HomeV5Service } from '../pages/home-v5/home-v5.service';
import { HomeUiService } from '../new-design/home-ui.service';
import { CordovaService } from '../cordova.service';
import { I18n } from '../i18n.service';
import { FullScreenDocumentComponent } from '../my-library/full-screen-document.component';
import { FullScreenVideoComponent } from '../full-screen-video/full-screen-video.component';
import { FullScreenAudioComponent } from '../full-screen-audio/full-screen-audio.component';
import { MatDialog } from '@angular/material/dialog';
import { FeedbackFormComponent } from '../components/commitments/feedback-form/feedback-form.component';
import { SpinnerService } from '../spinner.service';
import { ToasterService } from '../toaster.service';
import { MyCommitmentsService } from '../my-commitments/my-commitments.service';
import { Router } from '@angular/router';
import { DailyStepsContentWebModalV2Component } from '../new-design/daily-steps-content-web-modal-v2/daily-steps-content-web-modal-v2.component';
import { KyperDataApiService } from '../services/kyper-data-api.service';

export interface CalendarParams {
  title: String,
  startDate: Date
  endDate: Date,
  eventLocation: String,
  notes: String,
  endEventTime: any,
  frequency: string
}
@Component({
  selector: 'app-action-hub',
  templateUrl: './action-hub.component.html',
  styleUrls: ['./action-hub.component.scss'],
  animations: [
    slideOutRightAnimation({ duration: 500 }),
    collapseAnimation({ duration: 150 }),
    expandOnEnterAnimation({ duration: 250 }),
    collapseOnLeaveAnimation({ duration: 250 })
  ]
})
export class ActionHubComponent implements OnInit, DoCheck {

  active_todoLevelsList = []
  habitCommitmentIndex;
  actionCommitmentIndex;
  routineClicked = []
  isRoutineExpanded: boolean[] = [];
  actionClicked = []
  isActionExpanded: boolean[] = [];
  isDataFetched = false;
  @ViewChildren('slidingItem') slidingItem: IonItemSliding[];
  calendarParams: CalendarParams
  todoLevelsList: any []
  currentRoutine: any
  currentUser: any
  currentPath: any
  isMobile;
  todoRoutines: any
  todoActions: any =[]
  checked: boolean = false
  actionId: number
  videoFormats = ['.mp4', '.mov', '.avi', '.avchd', '.f4v', '.mkv', '.wmv', 'youtube.com', 'webm', 'html5', 'HTML5', 'watch'];
  audioFormats = [".mp3"];
  selectedLevels = []
  isActionTaken = false;
  isInitiallyLoadedToDo = false;
  isIonListActive = false;
  isContentVisible = false;
  active_levels_length = 0;
  @Output() onLogaRep: any = new EventEmitter<any>();
  @Output() screenCompletionDataEvent = new EventEmitter<any>();
  constructor(public modalController: ModalController,
    private appState: AppState,
    private routineService: RoutineV2Service,
    private dialog: MatDialog,
    private dailyStepsService: DailyStepsService,
    private homev5Service: HomeV5Service,
    private cdRef: ChangeDetectorRef,
    public homeUIService: HomeUiService,
    public i18n: I18n,
    public route: Router,
    public platform : Platform,
    private habitService: HabitService,
    private spinnerService: SpinnerService,
    private toasterService: ToasterService,
    public commitService: MyCommitmentsService,
    private cordovaService: CordovaService,
    private dailyStepsContent: DailyStepsContentWebModalV2Component,
    private kyperApiService: KyperDataApiService
  ) {
    this.currentUser = this.appState.get('currentUser')
    this.currentPath = this.appState.get('currentPath')
    this.fetchItemsInTodoList();
    this.isMobile = this.appState.get('isMobile');
  }
  async ngOnInit() {
    await this.getActions(this.currentPath.id)
    this.getHabits(this.currentPath.id)
   }

  ngDoCheck(): void {
    this.todoLevelsList = this.homev5Service.removeDuplicates(this.appState.get('todoRoutines'), "habitGroupId")?.filter((habit)=>habit.isHabitOpted);
    this.sortOnlyActiveHabits()
    this.todoActions = this.appState.get('todoActions')?.filter((action)=>action.id && !action.userActionCompletion&& action.userActionScheduledLater) 
  }
  fetchItemsInTodoList() {
    this.isInitiallyLoadedToDo = true;
    let routine= this.appState.get('todoRoutines')
    let action = this.appState.get('todoActions')
    if (routine?.length > 0) {
      this.todoLevelsList = this.homev5Service.removeDuplicates(routine, "habitGroupId")?.filter((habit)=>habit.isHabitOpted);
      this.sortOnlyActiveHabits()
    }
    if (action.length > 0) {
      this.todoActions = action?.filter((action)=>action.id && !action.userActionCompletion && action.userActionScheduledLater ) ;
    }
    console.log("routines and actions", routine,action)
    this.updateActionTakenFromData()
  }

  // isActionTaken resets when the component is recreated (e.g. app relaunch),
  // so derive it from the user's completed actions / logged reps as well
  updateActionTakenFromData() {
    const actions = this.appState.get('todoActions')
    const habitGroups = this.appState.get('todoRoutines')
    const isAnyActionCompleted = actions?.some((action: any) => action?.userActionCompletion)
    const isAnyRepLogged = habitGroups?.some((group: any) => group?.habits?.some((level: any) =>
      level?.isHabitCompleted || level?.repsData?.some((rep: any) => rep?.is_completed)))
    if (isAnyActionCompleted || isAnyRepLogged) {
      this.isActionTaken = true
    }
  }

  sortOnlyActiveHabits() {
   // let todoLevelsList =[]
    this.todoLevelsList = this.todoLevelsList?.filter(habit => 
    habit?.habits && habit?.habits?.some(level => level?.isHabitUnlocked ==true  && level?.isHabitCompleted === false));
    //this.todoLevelsList = todoLevelsList;
  }
  getActions( pathId: number) {
    const requestData = {
      'path_id': pathId
    }
    this.kyperApiService.getActionsList(requestData).subscribe((response) => {
      console.log("etered")
      if (!this.isInitiallyLoadedToDo) {
        this.todoActions =response?.actions?.filter((action)=>action.id&& !action.userActionCompletion && action.userActionScheduledLater) 
      }
      this.appState.set('todoActions', response?.actions)
      this.updateActionTakenFromData()
       if (!this.isActionTaken && this.isDataFetched) {
          setTimeout(() => {
            this.isActionTaken = true;
          },0);
        }
      //  this.isDataFetched =false
      this.isInitiallyLoadedToDo = false;
      this.cdRef.detectChanges();
    }, (error) => {
      console.log('error :', error);
       this.isDataFetched =false
    })
  }

  getHabits( pathId: number) {
    const requestData = {
      'path_id': pathId
    }
    this.kyperApiService.getHabitsList(requestData).subscribe((response) => {
      console.log("etered")
      let todoLevelsList = this.homev5Service.removeDuplicates(response?.habits, "habitGroupId");
      if (!this.isInitiallyLoadedToDo) {
        this.todoLevelsList = todoLevelsList.filter((habit)=>habit.isHabitOpted)
        this.sortOnlyActiveHabits()
      }
      this.appState.set('todoRoutines', todoLevelsList)
      this.updateActionTakenFromData()
       if (!this.isActionTaken && this.isDataFetched) {
          setTimeout(() => {
            this.isActionTaken = true;
          },0);
        }
       this.isDataFetched =false
      this.isInitiallyLoadedToDo = false;
      this.cdRef.detectChanges();
    }, (error) => {
      console.log('error :', error);
       this.isDataFetched =false
    })
  }
  async openReviewModal(event: Event, action) {

    const skipButton = document.querySelector('.skip-btn');
    if (skipButton) {
      skipButton.classList.add('skip-btn-change');
    
      // If you want to remove the class after some time
      setTimeout(() => {
        skipButton.classList.remove('skip-btn-change');
      }, 2000);
    }

    //event.stopPropagation();
    this.actionId = action.id
    this.checked = true
    this.habitConfirm_condensed(action);
  }

  habitConfirm_condensed(habit) {
    var isHabitComplete =  habit?.userActionCompletion
    let input = {
      step_id:habit.stepId,
      screen_id:habit.screenId,
      screen_content_id:habit.screenContentId,
      user_action_completion:true,
      customization_id: habit?.customizationId,
      action_date_time:this.kyperApiService.formatDate()
     }
    try {
      this.kyperApiService.schedule_commit_action_kyper(input).subscribe(res => {
        // this.spinnerService.off()
        habit.userActionCompletion = true
        habit.userActionScheduledLater = false
        this.isActionTaken = true
        this.cdRef.detectChanges()
         try {
      if (this.currentPath.enabledAttributes?.feedback && !isHabitComplete) {
        this.inithabitModal(habit)
      }
      else {
        this.isDataFetched =true
        this.closeOpenItems();
        this.getActions( this.currentPath.id);
        this.cdRef.detectChanges()
      }
    } catch (o_O) {
      console.log(o_O);
    }
      })
    } catch (o_0) {
      console.log('Errors ', o_0)
    }
   
  }
  async inithabitModal(habit) {
    // this.appState.set('currentDay', habit.startDay)
    const modal = await this.modalController.create({
      component: CompletedReviewModalComponent,
      componentProps: { currentHabit: habit },
      cssClass: this.isMobile ? 'mobile-custom-to_do_list-forms' : 'web_feedbackForm_modal'
    });
    modal.onDidDismiss().then((modalDataResponse) => {
      if (modalDataResponse !== null) {
        this.appState.set("isCommented", false)
      }
      this.appState.set('updateActionPoints', true)
       this.isDataFetched =true
      this.closeOpenItems();
      this.getActions(this.currentPath.id)
    });
    return await modal.present();
  }
  getRoutineLevelInfo(routine, index) {
    this.active_todoLevelsList[index] = this.homeUIService.getRoutineLevel(routine)
    this.active_levels_length = this.active_todoLevelsList[index]?.length
    if (this.active_todoLevelsList[index]?.length > 0) {
      return true
    }
    else {
      return false;
    }
  }

  closeOpenItems(index?) {
    if (this.slidingItem) {
      this.slidingItem.forEach((item) => {
        item.closeOpened();
        this.actionCommitmentIndex = null;
        this.habitCommitmentIndex = null;
      });
    }
  }

  openOptions(item: IonItemSliding, index, type) {
    this.isIonListActive = !this.isIonListActive;
    this.closeOpenItems(index);
    if (type == 'action') {
      this.actionCommitmentIndex = index;
    }
    else {
      this.habitCommitmentIndex = index;
    }
    item.open('start');
  }

  toggleExpandRoutine(index) {
    this.isContentVisible = !this.isContentVisible;
    if (this.routineClicked[index]) {
      setTimeout(() => {
        this.routineClicked[index] = !this.routineClicked[index]
      }, 200);
    }
    else {
      this.routineClicked[index] = !this.routineClicked[index]
    }
    this.isRoutineExpanded[index] = !this.isRoutineExpanded[index];
  }
  
  getLevelTitle(level) {
    return level?.title
  }

  toggleExpandAction(index: number) {
    if (this.actionClicked[index]) {
      setTimeout(() => {
        this.actionClicked[index] = !this.actionClicked[index]
      }, 200);
    }
    else {
      this.actionClicked[index] = !this.actionClicked[index]
    }
    this.isActionExpanded[index] = !this.isActionExpanded[index];
  }

  openDocument(postDoc) {
    //let post=this.actionList
    let path = this.appState.get('currentPath')
    let posts = this.appState.get("casualDocuments")
    let doc = this.appState.get('singleDocument');
    let post;
     posts?.forEach((doc)=>{
      if(doc.id ==postDoc?.tool?.id){
        post =doc;
      }
    })
    if (post?.id == doc?.id) {
      post = this.appState.get('singleDocument')
    }
    console.log('casual post :', post);
    // let post;
    // posts?.forEach((doc)=>{
    //   if(doc?.id ==id){
    //     post =doc
    //   }
    // })
    this.appState.set('singleDocument', post)
    this.appState.set('journalPost', undefined)
    if (post.isRecommended && post.isRecommended === true) {
      this.appState.set('isCasualDocument', true)
    }
    if (this.isMobile) {
      this.dialog.closeAll();
    }
    else {
      // this.modalController.dismiss();
    }
    this.appState.set('journalPathName', this.currentPath.name)
    let stepNumber = path.findChapterStepByScreenContentId(this.appState.get('DailyStepsData'), post.screenId,true)?.stepPosition;
    this.appState.set('journalStepNumber', stepNumber)
    const url = post.link;
    if (this.audioFormats.some(el => url.includes(el))) {
      console.log('Audio File');
      // this.route.navigate(['/audio-library'], { state: { data: post } })
      if (this.isMobile) {
        this.homeUIService.openNextComponent(FullScreenAudioComponent, { data: post })
      }
      else {
        this.homeUIService.openNextComponent(FullScreenAudioComponent, { data: post }, 'desktop-library-custom')
      }
    } else if (this.videoFormats.some(el => url.includes(el))) {
      console.log('Video File');
      // this.route.navigate(['/video-library'], { state: { data: post } })
      if (this.isMobile) {
        this.homeUIService.openNextComponent(FullScreenVideoComponent, { data: post })
      }
      else {
        this.homeUIService.openNextComponent(FullScreenVideoComponent, { data: post }, 'desktop-library-custom')
      }
  
    } else {
      console.log('Document');
      // this.route.navigate(['/detail-document'])
      if (this.isMobile) {
        this.homeUIService.openNextComponent(FullScreenDocumentComponent)
      }
      else {
        this.homeUIService.openNextComponent(FullScreenDocumentComponent, '', 'desktop-library-custom')
      }
  
       
    }
  }
  
  getTitle(title) {
    let prefixTranslated = this.i18n.t("My commitment: ")
    return title?.startsWith(prefixTranslated)
      ? title?.slice(prefixTranslated?.length).trim()
      : title;
  }

  async showFeedbackForm(subItem) {
    let currentRoutine = this.homeUIService.getRoutineByLevel(subItem, this.todoLevelsList)
    let repsIndex = subItem?.repsData.findIndex((item) => item.is_completed === false);
    if (repsIndex > -1) {
      const modal = await this.modalController.create({
        component: FeedbackFormComponent,
        componentProps: {
          mainItem: currentRoutine,
          subItem: subItem,
          index: repsIndex
        },
        cssClass: this.isMobile ? 'mobile-custom-to_do_list-forms' : 'web_feedbackForm_modal'
      });
      modal.onDidDismiss().then((modelData) => {
        if (modelData !== null && modelData.data !== undefined) {
          this.onLogaRep.emit(modelData.data);
          this.isDataFetched =true
          this.logaRep(currentRoutine, subItem, repsIndex)
        }
        else {
          this.closeOpenItems();
        }
      });
      return await modal.present();
    } else {
      this.cdRef.detectChanges()
      console.log('Complted level')
    }
  }
   getReps(item) {
    return item.repsData
   }
  fetchScreenTypeContent(screentype) {
    let dailyStepsArray = this.appState.get('DailyStepsData')
    return dailyStepsArray
  .map(step => step?.[screentype])
  .filter(s => s != null && (Array.isArray(s) ? s?.length > 0 : true))
  .flatMap(s => Array.isArray(s) ? s : [s]);
  }
  
   getCurrentRoutine(routine, level) {
    // let dailyStepsArray = this.appState.get('DailyStepsData')
     let unCheckedLevels = [];
    // let routineInfo= this.fetchScreenTypeContent('routineInfo');
    // routineInfo.forEach(currentRoutine => {
    //   if (currentRoutine.id === routine.routine_info_id) {
    //     currentRoutine.levels.forEach(routineLevel => {
          routine.habits.forEach(myLevel => {
            const match = routine.selectedHabitIds?.includes(myLevel.id)
            if (myLevel.id!=level.id && (match?.length === 0 && routine.selectedHabitIds?.length!=0)) {
              myLevel.enabled = false;
              unCheckedLevels.push({ 'id': myLevel.id, 'index': routine.habits.indexOf(myLevel) })
            }
        //   });
        // });
        unCheckedLevels = [...new Set(unCheckedLevels)];
      // }

      // function getUnique(arr, comp) {
      //   const unique = arr.map(e => e[comp])
      //     .map((e, i, final) => final.indexOf(e) !== i && i)
      //     .filter((e) => arr[e]).map(e => arr[e]);

      //   return unique;
      // }
      let unselectedIndex = routine.habits.findIndex(item => item.id === level.id);
      // this.appState.set('indexOfLevel', unselectedIndex + 1)
       let unCommittedLevel, unCommitedIndex;
      unCommittedLevel = this.homeUIService.getRoutineLockedLevel(routine)
      if (level?.isHabitUnlocked == true && unCommittedLevel) {
        unCommitedIndex = routine.habits.findIndex(item => item.id === unCommittedLevel?.id);
        this.appState.set('indexOfLevel', unCommitedIndex)
      }
      else {
         this.appState.set('indexOfLevel', unselectedIndex+1)
      }
      //this.appState.set('levelUpdated', true)
    });
     unCheckedLevels= unCheckedLevels.filter((value, index, self) => index === self.findIndex((t) => t.id === value.id));
      this.appState.set('unCheckedLevels',[...new Set(unCheckedLevels)] )
    this.selectedLevels = [];
     routine.habits.forEach(element => {
      let isPresentInUncheckedLevel = unCheckedLevels?.findIndex(item => item?.id === element.id)
      if (!routine.selectedHabitIds?.includes( element.id) && element.id ==level.id) {
        element.enabled = true;
        this.selectedLevels.push({ 'id': element.id, 'index': routine.habits.indexOf(element) })
      }
      // else if(element.enabled) {
      //    this.selectedLevels.push({ 'id': element.id, 'index': routine.habits.indexOf(element) })
      // }
      else if (routine.selectedHabitIds?.includes(element.id) || routine.selectedHabitIds?.length==0) {
         element.enabled = true;
         this.selectedLevels.push({ 'id': element.id, 'index': routine.habits.indexOf(element) })
      }
    });
    this.selectedLevels=[...new Set(this.selectedLevels)]
    this.appState.set('selectedLevelIds', this.selectedLevels)
  }

   logaRep(routine: any, level: any, index: any) {
    let repsCommitArray = routine.habits.filter(item => item.repsData)
    let repsArray = repsCommitArray.map(this.getReps)
    let totalRepsArray = Array.prototype.concat.apply([], repsArray);
    let totalLevelRepsArray = level.repsData.filter(item => item.is_completed === false)

    if (level.isHabitUnlocked === false) {
      this.toasterService.warning(this.i18n.t('Please complete previous level.'))
    } else {
      //this.spinnerService.on();
      this.commitService.setLoader(false);
      const requestData = {
        // 'user_id': this.currentUser.id,
        // 'path_id': routine.path_id,
        // 'routine_info_id': routine.routine_info_id,
        // 'level_id': level.id,
        // 'schedule_day': routine?.schedule_day,
        // 'feedback': localStorage.getItem('repLogText'),
        // 'step': index + 1
        habit_group_id: level.habitGroupId,
        habit_id: level.id,
        rep_feedback: localStorage.getItem('repLogText'),
        rep: level.repsData?.findIndex(item => item.is_completed === false)+1
      }

      // this.getRoutines(this.currentUser?.id, this.currentPath.id);
      this.routineService.replog(requestData).subscribe(
        (response) => {
          let object = null
        //  this.spinnerService.off();
          this.commitService.setLoader(true);
          // add reply to the local path routine_info
          // if (response && response.data && response.data.routine_info_id) {
          //   object = this.fetchScreenTypeContent('routineInfo')?.find(q => q?.id === response.data.routine_info_id)
          // }

          this.toasterService.success(this.i18n.t('Rep Logged!'))
          this.isActionTaken = true
          this.closeOpenItems();
          console.log('Response for feedback ', response)
          this.getHabits(this.currentPath.id);
          this.cdRef.detectChanges();
          var isLastRepLogged = level.repsData.filter(item => item.is_completed === true)

          const last = routine.habits[routine.habits.length - 1];
          this.appState.set('isTodoReps', undefined)
          // if (level.reps_commit.length == isLastRepLogged.length + 1  && last.id === level.id) {
          //   this.checkLastRep(routine)
          // } else
            if (totalLevelRepsArray.length - 1 === 0 ) {
            // this.appState.set('LevelNumber', level.level + 1)
             this.appState.set('levelUpdated', undefined)
            this.getCurrentRoutine(routine,level)
              // this.appState.set('showUpdatedScreens', true)
              var data = {
                levelUpdated: true,
                routine: routine,
                level: level
              }
              this.appState.set('levelUpdateData', data)
              this.appState.set('isLevelReoptedFromActionHubScreen', true)
              if (this.isMobile) {
                this.route.navigate(['/main'])
              }
              else {

                this.dailyStepsContent.close('isInstepTodoScreen');
             }
            //this.homeUIService.openAlertGiveFeedbackCommitmentComponent(routine,level)
            // if (routine.path_id === this.currentPath.id) {
            //   this.appState.set('isLevelCommited',false);
            //   this.appState.set("allowScreenCount", undefined)
            //   // TODO: differentiate between mobile and web for routing
            //   if (this.isMobile) {
            //     this.route.navigate(['/content', this.routineDay], { queryParams: { startFromScreen: 'daily-content-screen-routine' } })
            //   } else {
            //     this.commitService.closeModals()
            //     setTimeout(() => {
            //       this.homeUIService.openNextComponent(DailyStepsContentWebModalV2Component,{currentDay: this.routineDay,startFromScreen: 'daily-content-screen-routine'},'web-daily-steps-custom-modal')                  
            //     }, 1100);
            //   }
              
            // } else {
            //   this.changeSubPath(routine.path_id, this.routineDay)
            // }
          } else {
            console.log('inside else:',);
          }

        },
        (error) => {
          //this.spinnerService.off()
          this.toasterService.error(this.i18n.t("Server or connection issue. Please check your internet connection."));
          console.log('Error for feedback ', error)
        }
      )
    }
  }
  
  nextStepEndScreen() {
    this.screenCompletionDataEvent.emit({ 'isNextButttonClicked': true })
  }  

  @HostListener('document:click', ['$event'])
  onClick(e) {
    const target = e.target as HTMLElement;
    console.log("target in community", target, e.target.target, e.target.tagName.toLowerCase());
    const parent = target.closest('.web-todo-name');
    if (parent && this.cordovaService.onCordova && this.platform.is('ios')) {

      const href = target.getAttribute('href');
      if (href && e.target.tagName.toLowerCase() == 'a' && e.target.target == '_blank') {
       e.stopPropagation()
        e.preventDefault()
        this.cordovaService.openLinkInBrowser(e.target?.href);
      }
    }
  }

}

